<template>
<div class="mu-calendar-toolbar">
  <div class="mu-calendar-toolbar-title-wrapper">
    <transition :name="'mu-calendar-slide-' + slideType"  v-for="displayDate, index in displayDates" :key="index">
      <div class="mu-calendar-toolbar-title" :key="displayDate.getTime()">
        {{dateTimeFormat.formatMonth(displayDate)}}
      </div>
    </transition>
  </div>
</div>
</template>

<script>
export default {
  props: {
    dateTimeFormat: {
      type: Object
    },
    displayDates: {
      type: Array
    },
    slideType: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewDatePicker/calendarToolbar.vue